module.exports = __webpack_public_path__ + "img/commandeSubstitution.84bd5321.png";